<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    :top="centered"
    :bottom="!centered && position === 'bottom'"
    :left="!centered && position === 'left'"
    :right="!centered && position === 'right'"
    :multi-line="multiLine"
    :class="{ 'snackbar-centered': centered }"
    :style="centered ? 'top: 50% !important; transform: translateY(-50%);' : ''"
  >
    <div class="d-flex align-center">
      <span>{{ message }}</span>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        v-if="showCloseButton"
        icon
        v-bind="attrs"
        @click="show = false"
        class="close-btn-no-bg"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <v-btn
        v-else
        text
        v-bind="attrs"
        @click="show = false"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'GlobalSnackbar',
  data() {
    return {
      show: false,
      message: '',
      color: 'success',
      timeout: 3000,
      position: 'top',
      multiLine: false,
      centered: false,
      icon: null,
      iconColor: 'white',
      showCloseButton: false
    }
  },
  methods: {
    showSnackbar({ message, color = 'success', timeout = 3000, position = 'top', multiLine = false }) {
      this.message = message
      this.color = color
      this.timeout = timeout
      this.position = position
      this.multiLine = multiLine
      this.centered = false
      this.showCloseButton = false
      
      if (color === 'success') {
        this.icon = 'mdi-check-circle'
        this.iconColor = 'white'
      } else if (color === 'error') {
        this.icon = 'mdi-alert-circle'
        this.iconColor = 'white'
      } else if (color === 'warning') {
        this.icon = 'mdi-alert'
        this.iconColor = 'white'
      } else if (color === 'info') {
        this.icon = 'mdi-information'
        this.iconColor = 'white'
      } else {
        this.icon = null
      }
      
      this.show = true
    },
    success(message, timeout = 3000) {
      this.showSnackbar({ message, color: 'success', timeout })
    },
    error(message, timeout = 4000) {
      this.showSnackbar({ message, color: 'error', timeout })
    },
    warning(message, timeout = 3500) {
      this.showSnackbar({ message, color: 'warning', timeout })
    },
    info(message, timeout = 3000) {
      this.showSnackbar({ message, color: 'info', timeout })
    },
    successWithAction(message, timeout = -1) {
      this.message = message
      this.color = 'success'
      this.timeout = timeout
      this.position = 'top'
      this.multiLine = true
      this.centered = true
      this.icon = null
      this.iconColor = 'white'
      this.showCloseButton = true
      this.show = true
    }
  }
}
</script>

<style scoped>
.snackbar-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.snackbar-centered .v-snack__wrapper {
  margin: 0 auto;
}
.close-btn-no-bg {
  background: transparent !important;
}
.close-btn-no-bg::before {
  background: transparent !important;
}
</style>
